import React from 'react';
import TableComponent from '../../../SharedComponents/Table';
import BasicButton from '../../../SharedComponents/BasicButton/BasicButton';
import { licensorQuickViewTableConfig, buildLicensorSummaryRows } from './licensorQuickViewConfig';
import './LicensorQuickView.scss';

const LicensorQuickView = ({
    licensors = [],
    isMainTitle = false,
    selectedIndex = null,
    isEditingLocked = false,
    onSelect,
    onAdd,
}) => {
    const rows = buildLicensorSummaryRows(licensors, isMainTitle);

    const handleRowClick = (_event, _dataItem, index) => {
        if (isEditingLocked) {
            return;
        }
        onSelect(index);
    };

    return (
        <div className="licensor-quick-view">
            <div className="licensor-quick-view-header">
                <div className="licensor-quick-view-title-group">
                    <span className="licensor-quick-view-title">Licensors</span>
                    <span className="licensor-quick-view-count">{rows.length}</span>
                </div>
                {onAdd && (
                    <BasicButton
                        variant="contained"
                        type="inline"
                        color="primary"
                        text="Add a Licensor"
                        onClick={onAdd}
                    />
                )}
            </div>
            <div className={`licensor-quick-view-table${isEditingLocked ? ' is-editing-locked' : ''}`}>
                <TableComponent
                    list={rows}
                    config={licensorQuickViewTableConfig}
                    className="licensorQuickView"
                    tableMode="light"
                    stickyHeader={true}
                    initialRightsFlag={!isEditingLocked}
                    initialRightsRowClick={handleRowClick}
                    selectedIndex={selectedIndex}
                    sortCallback={() => {}}
                />
            </div>
            {isEditingLocked ? (
                <div className="licensor-quick-view-editing-note">
                    Save or cancel the current licensor edit before selecting another licensor.
                </div>
            ) : (
                <div className="licensor-quick-view-hint">
                    Select a row to open full licensor details.
                </div>
            )}
        </div>
    );
};

export default LicensorQuickView;
